import { ReactComponent as UnexpectedErrorImage } from '@assets/images/undraw_404.svg';
import { Button, Container, Stack, useTheme } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { ErrorDetails } from '../components/ErrorDetails';
import { ErrorPageLayout } from '../layouts/ErrorPageLayout';

export const NotFoundPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <ErrorPageLayout>
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <ErrorDetails
          image={<UnexpectedErrorImage fill={theme.palette.primary.main} />}
          title={formatMessage({ id: 'Page not found' })}
          message={formatMessage({ id: 'The page you tried to view does not exist.' })}
        />
        <Stack direction="row" justifyContent='center' alignItems='center' spacing={2} sx={{ marginTop: 3 }}>
          <Button variant="outlined" onClick={() => navigate(-1)}>{formatMessage({ id: 'Back' })}</Button>
          <Button variant="contained" onClick={() => navigate('/')}>{formatMessage({ id: 'Home' })}</Button>
        </Stack>
      </Container>
    </ErrorPageLayout >
  );
};